import language from "./../../src/common/i18n/fr_BE.json";

const dictionary = language;

// If needed, you can add or override translations here for the current client
dictionary.E7 =
  "Il semble que votre mot de passe ou adresse mail ne soit pas reconnu(e). Veuillez réessayer à nouveau. Si besoin, n'hésitez pas à contacter notre équipe de support via mail à contact@ipmgroup.be.";
dictionary.E24 =
  "Il semble que votre compte ne soit pas associé à un abonnement actif ou que votre abonnement en cours ne permette pas l'accès à ce journal. Si besoin, n'hésitez pas à contacter notre équipe de support via mail à contact@ipmgroup.be.";

dictionary.account = "Statut";
dictionary.accountLoggedWithInfo = "Vous êtes connecté avec le compte :";
dictionary.accountLoggedInInfo =
  "Si vous vous êtes abonné via le webshop de DH, vous pouvez gérer votre abonnement depuis votre centre de profil sur dhnet.be.";
dictionary.notifications_title = "oops";
dictionary.ForgotPassword = "Mot de passe oubli\u00E9 ?";
dictionary.cropPrintInstruction = "S\u00E9lectionnez la zone \u00E0 imprimer";
dictionary.Promospot = "Suppl\u00E9ments";
dictionary.dataPolicy = "Politique de la Vie Privée";
dictionary.openCMPSetting = "Modifier mes paramètres des cookies";
dictionary.Archive = "Éditions précédentes";

export default dictionary;



// WEBPACK FOOTER //
// ./clients/tec-ldh/dictionary.js